import CustomUserInput from "./components/chatbot/audio/UserInput.vue";

/**
 * Override vue beatiful chat.
 * The base library doesn't allow to inject your own components, so you need
 * to override and redifine the Launcher component with your own ones.
 *
 * At least we need to override the UserInput.
 */
export default function overrideBeautifulChat(Vue) {
  const Launcher = Vue.component("BeautifulChat");
  const ChatWindow = Launcher.options.components.ChatWindow;
  const UserInput = ChatWindow.components.UserInput;

  Vue.component("BeautifulChat", {
    extends: Launcher,
    mounted() {
      this.$nextTick(() => this._patchLauncher());
    },
    updated() {
      this.$nextTick(() => this._patchLauncher());
    },
    methods: {
      _patchLauncher() {
        const launcher = this.$el && this.$el.querySelector(".sc-launcher");
        if (!launcher) return;

        const isOpen = launcher.classList.contains("opened");
        launcher.setAttribute("role", "button");
        launcher.setAttribute("tabindex", "0");
        launcher.setAttribute(
          "aria-label",
          isOpen ? "close chatbot" : "open chatbot"
        );

        if (!launcher._a11yPatchApplied) {
          launcher._a11yPatchApplied = true;
          launcher.addEventListener("keydown", e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              launcher.click();
            }
          });
        }
      }
    },
    components: {
      ChatWindow: {
        extends: ChatWindow,
        components: {
          UserInput: {
            components: UserInput.components,
            mixins: [UserInput, CustomUserInput]
          }
        }
      }
    }
  });
}
